export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/template/copywriting/tag/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/template/copywriting/tag/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/template/copywriting/tag/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      remove(data) {
          return http.json({
              url: `/template/copywriting/tag/deleteByTid?tid=${data[0].id}`,
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/template.js